var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"bc-svg-icon",class:`bc-icon-${_vm.name}`,attrs:{"aria-hidden":"true","role":"img"},on:{"click":_vm.click}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }